import { render } from "./Recovery.vue?vue&type=template&id=f1ebd552"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"
script.render = render

export default script